import { render, staticRenderFns } from "./VerifyMobile.vue?vue&type=template&id=4d83fd10&"
import script from "./VerifyMobile.vue?vue&type=script&lang=js&"
export * from "./VerifyMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports